module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7d7ec7dadfa937027f379bb16b60bbf4.png";